import { Outlet } from "react-router-dom";

const Register = () => {
  return <Outlet />;
};

export default Register;
